import {
  LandingNavigation,
  LandingHero,
  LandingHowItWorks,
  LandingBentoFeatures,
  LandingSubscriberExperience,
  LandingUseCases,
  LandingFooter,
} from "./components";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-dark-primary text-text-primary font-inter overflow-x-hidden">
      <LandingNavigation />
      <LandingHero />
      <LandingHowItWorks />
      <LandingBentoFeatures />
      <LandingSubscriberExperience />
      <LandingUseCases />
      <LandingFooter />
    </div>
  );
}
